module.exports = __webpack_public_path__ + "img/ブシャダ　イリャス.7a24c03f.jpg";